export default __webpack_public_path__ + "static/media/SmartLogistics.f4f0c9d7.png";